<template>
    <div class="border-b border-grey-500 py-4 grid grid-cols-3 lg:grid-cols-5 lg:flex justify-between w-full gap-y-4">
        <div class="flex items-center lg:col-span-2 col-span-3 border-b border-grey-500 pb-4 lg:py-0 lg:border-b-0">
            <IconZapoAdsLogo class="w-6 h-6" v-if="productId == 1" />
            <IconZapoCrmLogo class="w-6 h-6" v-if="productId == 2" />

            <div class="pl-3">
                <p class="text-15 font-semibold" v-if="productId == 1">{{ industry.name }} / {{ area.name }}</p>
                <p class="text-15 font-semibold" v-if="productId == 2">Zapo CRM</p>
                <p class="text-grey-900 text-14">{{ plan.name }}</p>
            </div>
        </div>

        <!-- lg:block flex items-center justify-between -->
         <div class='flex items-center justify-between shrink-0'>
            <div class="lg:pr-8">
                <p class="lg:text-15 text-14 font-semibold order-2 lg:order-1">{{ $help.dp(plan.monthly_cost, 0) }}+VAT</p>
                <p class="text-grey-900 lg:text-14 text-13 order-1 lg:order-2">Monthly cost</p>
            </div>

            <div class="lg:border-l border-grey-500 w-[160px] lg:pl-8" v-if="productId == 1">
                <p class="lg:text-15 text-14 font-semibold order-2 lg:order-1">{{ $help.dp(plan.ad_spend, 0) }}</p>
                <p class="text-grey-900 lg:text-14 text-13 order-1 lg:order-2">Ad spend</p>
            </div>

            <div class="lg:border-l border-grey-500 lg:pr-4 lg:pl-8 lg:min-w-[140px]">
                <p class="lg:text-15 text-14 font-semibold order-2 lg:order-1">
                    <template v-if="productId == 1">{{ plan.expected_leads_per_month }}</template>
                    <template v-if="productId == 2">
                        {{ plan.expected_leads_per_month == null ? 'Unlimited' : plan.expected_leads_per_month }}
                    </template>
                </p>
                <p class="text-grey-900 lg:text-14 text-13 order-1 lg:order-2">
                    <template v-if="productId == 1">Monthly leads</template>
                    <template v-if="productId == 2">{{ $help.pluralize('User', plan.expected_leads_per_month || 2) }}</template>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        area: Object,
        industry: Object,
        plan: Object,
        productId: Number,
    },
}
</script>
